/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DatabaseHealthCheckResult,
  DisplayPlatformContactDetailsResponse,
  DisplayPracticeTimeZoneResponse,
  GetPlatformContactDetailsParams,
  GetPlatformLocationsParams,
  GetPlatformLocationsResultPagedResults,
  GetPracticeTimeZoneParams,
  GetWidgetsParams,
  PlatformModel,
  ThemeModel,
  WidgetModel
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Retrieves the dedicated SMS numbers, website, and requested locations' office numbers and
addresses the practice's contact card lists, for the save-contact page to show beside its Save
contact button.
 */
export const getPlatformContactDetails = (
    platformId: string,
    params?: GetPlatformContactDetailsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayPlatformContactDetailsResponse>(
      {url: `/api/v1/public/platforms/${platformId}/contact-card`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPlatformContactDetailsQueryKey = (platformId: string,
    params?: GetPlatformContactDetailsParams,) => {
    return [
    `/api/v1/public/platforms/${platformId}/contact-card`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlatformContactDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformContactDetails>>, TError = ErrorType<void>>(platformId: string,
    params?: GetPlatformContactDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformContactDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformContactDetailsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformContactDetails>>> = ({ signal }) => getPlatformContactDetails(platformId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformContactDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformContactDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformContactDetails>>>
export type GetPlatformContactDetailsQueryError = ErrorType<void>


export function useGetPlatformContactDetails<TData = Awaited<ReturnType<typeof getPlatformContactDetails>>, TError = ErrorType<void>>(
 platformId: string,
    params: undefined |  GetPlatformContactDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformContactDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformContactDetails>>,
          TError,
          Awaited<ReturnType<typeof getPlatformContactDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformContactDetails<TData = Awaited<ReturnType<typeof getPlatformContactDetails>>, TError = ErrorType<void>>(
 platformId: string,
    params?: GetPlatformContactDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformContactDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformContactDetails>>,
          TError,
          Awaited<ReturnType<typeof getPlatformContactDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformContactDetails<TData = Awaited<ReturnType<typeof getPlatformContactDetails>>, TError = ErrorType<void>>(
 platformId: string,
    params?: GetPlatformContactDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformContactDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the dedicated SMS numbers, website, and requested locations' office numbers and
addresses the practice's contact card lists, for the save-contact page to show beside its Save
contact button.
 */

export function useGetPlatformContactDetails<TData = Awaited<ReturnType<typeof getPlatformContactDetails>>, TError = ErrorType<void>>(
 platformId: string,
    params?: GetPlatformContactDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformContactDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformContactDetailsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the platform details for the current host.
 */
export const platformGetPlatform = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformModel>(
      {url: `/api/v1/platform`, method: 'GET', signal
    },
      options);
    }




export const getPlatformGetPlatformQueryKey = () => {
    return [
    `/api/v1/platform`
    ] as const;
    }


export const getPlatformGetPlatformQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPlatform>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatform>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPlatformQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPlatform>>> = ({ signal }) => platformGetPlatform(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformGetPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPlatform>>>
export type PlatformGetPlatformQueryError = ErrorType<void>


export function usePlatformGetPlatform<TData = Awaited<ReturnType<typeof platformGetPlatform>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetPlatform>>,
          TError,
          Awaited<ReturnType<typeof platformGetPlatform>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetPlatform<TData = Awaited<ReturnType<typeof platformGetPlatform>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetPlatform>>,
          TError,
          Awaited<ReturnType<typeof platformGetPlatform>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetPlatform<TData = Awaited<ReturnType<typeof platformGetPlatform>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatform>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the platform details for the current host.
 */

export function usePlatformGetPlatform<TData = Awaited<ReturnType<typeof platformGetPlatform>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatform>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformGetPlatformQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get information regarding a specific Platform if you are registered to it
 */
export const platformGetPlatformByPlatformId = (
    platformId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformModel>(
      {url: `/api/v1/platform/${platformId}`, method: 'GET', signal
    },
      options);
    }




export const getPlatformGetPlatformByPlatformIdQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platform/${platformId}`
    ] as const;
    }


export const getPlatformGetPlatformByPlatformIdQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPlatformByPlatformIdQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>> = ({ signal }) => platformGetPlatformByPlatformId(platformId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformGetPlatformByPlatformIdQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>>
export type PlatformGetPlatformByPlatformIdQueryError = ErrorType<unknown>


export function usePlatformGetPlatformByPlatformId<TData = Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>,
          TError,
          Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetPlatformByPlatformId<TData = Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>,
          TError,
          Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetPlatformByPlatformId<TData = Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get information regarding a specific Platform if you are registered to it
 */

export function usePlatformGetPlatformByPlatformId<TData = Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformByPlatformId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformGetPlatformByPlatformIdQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get Platform details without needing authorization
 */
export const getCurrentPlatform = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformModel>(
      {url: `/api/v1/platform/current`, method: 'GET', signal
    },
      options);
    }




export const getGetCurrentPlatformQueryKey = () => {
    return [
    `/api/v1/platform/current`
    ] as const;
    }


export const getGetCurrentPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentPlatform>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentPlatform>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentPlatformQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentPlatform>>> = ({ signal }) => getCurrentPlatform(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentPlatform>>>
export type GetCurrentPlatformQueryError = ErrorType<unknown>


export function useGetCurrentPlatform<TData = Awaited<ReturnType<typeof getCurrentPlatform>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentPlatform>>,
          TError,
          Awaited<ReturnType<typeof getCurrentPlatform>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentPlatform<TData = Awaited<ReturnType<typeof getCurrentPlatform>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentPlatform>>,
          TError,
          Awaited<ReturnType<typeof getCurrentPlatform>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentPlatform<TData = Awaited<ReturnType<typeof getCurrentPlatform>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentPlatform>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Platform details without needing authorization
 */

export function useGetCurrentPlatform<TData = Awaited<ReturnType<typeof getCurrentPlatform>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentPlatform>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentPlatformQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get the list of a platform's locations
 */
export const getPlatformLocations = (
    params?: GetPlatformLocationsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GetPlatformLocationsResultPagedResults>(
      {url: `/api/v1/platform/locations`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPlatformLocationsQueryKey = (params?: GetPlatformLocationsParams,) => {
    return [
    `/api/v1/platform/locations`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlatformLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformLocations>>, TError = ErrorType<unknown>>(params?: GetPlatformLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformLocationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformLocations>>> = ({ signal }) => getPlatformLocations(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformLocations>>>
export type GetPlatformLocationsQueryError = ErrorType<unknown>


export function useGetPlatformLocations<TData = Awaited<ReturnType<typeof getPlatformLocations>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPlatformLocationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocations>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocations<TData = Awaited<ReturnType<typeof getPlatformLocations>>, TError = ErrorType<unknown>>(
 params?: GetPlatformLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocations>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocations<TData = Awaited<ReturnType<typeof getPlatformLocations>>, TError = ErrorType<unknown>>(
 params?: GetPlatformLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the list of a platform's locations
 */

export function useGetPlatformLocations<TData = Awaited<ReturnType<typeof getPlatformLocations>>, TError = ErrorType<unknown>>(
 params?: GetPlatformLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets the time zone the current practice's active locations share, so the app can show dates such as
a promotional gift card's expiry on the practice's calendar.
 */
export const getPracticeTimeZone = (
    params?: GetPracticeTimeZoneParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayPracticeTimeZoneResponse>(
      {url: `/api/v1/platform/time-zone`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPracticeTimeZoneQueryKey = (params?: GetPracticeTimeZoneParams,) => {
    return [
    `/api/v1/platform/time-zone`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPracticeTimeZoneQueryOptions = <TData = Awaited<ReturnType<typeof getPracticeTimeZone>>, TError = ErrorType<unknown>>(params?: GetPracticeTimeZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeTimeZone>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPracticeTimeZoneQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeTimeZone>>> = ({ signal }) => getPracticeTimeZone(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPracticeTimeZone>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPracticeTimeZoneQueryResult = NonNullable<Awaited<ReturnType<typeof getPracticeTimeZone>>>
export type GetPracticeTimeZoneQueryError = ErrorType<unknown>


export function useGetPracticeTimeZone<TData = Awaited<ReturnType<typeof getPracticeTimeZone>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPracticeTimeZoneParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeTimeZone>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeTimeZone>>,
          TError,
          Awaited<ReturnType<typeof getPracticeTimeZone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPracticeTimeZone<TData = Awaited<ReturnType<typeof getPracticeTimeZone>>, TError = ErrorType<unknown>>(
 params?: GetPracticeTimeZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeTimeZone>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeTimeZone>>,
          TError,
          Awaited<ReturnType<typeof getPracticeTimeZone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPracticeTimeZone<TData = Awaited<ReturnType<typeof getPracticeTimeZone>>, TError = ErrorType<unknown>>(
 params?: GetPracticeTimeZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeTimeZone>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the time zone the current practice's active locations share, so the app can show dates such as
a promotional gift card's expiry on the practice's calendar.
 */

export function useGetPracticeTimeZone<TData = Awaited<ReturnType<typeof getPracticeTimeZone>>, TError = ErrorType<unknown>>(
 params?: GetPracticeTimeZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeTimeZone>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPracticeTimeZoneQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get theme information for specified platform
 */
export const getTheme = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ThemeModel>(
      {url: `/api/v1/platform/theme`, method: 'GET', signal
    },
      options);
    }




export const getGetThemeQueryKey = () => {
    return [
    `/api/v1/platform/theme`
    ] as const;
    }


export const getGetThemeQueryOptions = <TData = Awaited<ReturnType<typeof getTheme>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTheme>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetThemeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTheme>>> = ({ signal }) => getTheme(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTheme>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetThemeQueryResult = NonNullable<Awaited<ReturnType<typeof getTheme>>>
export type GetThemeQueryError = ErrorType<unknown>


export function useGetTheme<TData = Awaited<ReturnType<typeof getTheme>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTheme>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTheme>>,
          TError,
          Awaited<ReturnType<typeof getTheme>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTheme<TData = Awaited<ReturnType<typeof getTheme>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTheme>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTheme>>,
          TError,
          Awaited<ReturnType<typeof getTheme>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTheme<TData = Awaited<ReturnType<typeof getTheme>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTheme>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get theme information for specified platform
 */

export function useGetTheme<TData = Awaited<ReturnType<typeof getTheme>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTheme>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetThemeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Checks whether the patient database is reachable.
 */
export const getDatabaseHealthCheck = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DatabaseHealthCheckResult>(
      {url: `/api/status`, method: 'GET', signal
    },
      options);
    }




export const getGetDatabaseHealthCheckQueryKey = () => {
    return [
    `/api/status`
    ] as const;
    }


export const getGetDatabaseHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof getDatabaseHealthCheck>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseHealthCheck>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatabaseHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatabaseHealthCheck>>> = ({ signal }) => getDatabaseHealthCheck(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatabaseHealthCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatabaseHealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof getDatabaseHealthCheck>>>
export type GetDatabaseHealthCheckQueryError = ErrorType<unknown>


export function useGetDatabaseHealthCheck<TData = Awaited<ReturnType<typeof getDatabaseHealthCheck>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseHealthCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseHealthCheck>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseHealthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseHealthCheck<TData = Awaited<ReturnType<typeof getDatabaseHealthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseHealthCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseHealthCheck>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseHealthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseHealthCheck<TData = Awaited<ReturnType<typeof getDatabaseHealthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseHealthCheck>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Checks whether the patient database is reachable.
 */

export function useGetDatabaseHealthCheck<TData = Awaited<ReturnType<typeof getDatabaseHealthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseHealthCheck>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatabaseHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Redirects users to the base URL of the current request.
This is to continue supporting V1 QR codes pointing to this endpoint
 */
export const redirectToBaseUrl = (
    platformLocationId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/checkIn/location/${platformLocationId}`, method: 'GET', signal
    },
      options);
    }




export const getRedirectToBaseUrlQueryKey = (platformLocationId: string,) => {
    return [
    `/api/checkIn/location/${platformLocationId}`
    ] as const;
    }


export const getRedirectToBaseUrlQueryOptions = <TData = Awaited<ReturnType<typeof redirectToBaseUrl>>, TError = ErrorType<void>>(platformLocationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectToBaseUrl>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRedirectToBaseUrlQueryKey(platformLocationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof redirectToBaseUrl>>> = ({ signal }) => redirectToBaseUrl(platformLocationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: platformLocationId !== null && platformLocationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof redirectToBaseUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RedirectToBaseUrlQueryResult = NonNullable<Awaited<ReturnType<typeof redirectToBaseUrl>>>
export type RedirectToBaseUrlQueryError = ErrorType<void>


export function useRedirectToBaseUrl<TData = Awaited<ReturnType<typeof redirectToBaseUrl>>, TError = ErrorType<void>>(
 platformLocationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectToBaseUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof redirectToBaseUrl>>,
          TError,
          Awaited<ReturnType<typeof redirectToBaseUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedirectToBaseUrl<TData = Awaited<ReturnType<typeof redirectToBaseUrl>>, TError = ErrorType<void>>(
 platformLocationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectToBaseUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof redirectToBaseUrl>>,
          TError,
          Awaited<ReturnType<typeof redirectToBaseUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedirectToBaseUrl<TData = Awaited<ReturnType<typeof redirectToBaseUrl>>, TError = ErrorType<void>>(
 platformLocationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectToBaseUrl>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Redirects users to the base URL of the current request.
This is to continue supporting V1 QR codes pointing to this endpoint
 */

export function useRedirectToBaseUrl<TData = Awaited<ReturnType<typeof redirectToBaseUrl>>, TError = ErrorType<void>>(
 platformLocationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectToBaseUrl>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRedirectToBaseUrlQueryOptions(platformLocationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List all widgets that appear on the specified page
 */
export const getWidgets = (
    params: GetWidgetsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<WidgetModel[]>(
      {url: `/api/v1/widgets`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetWidgetsQueryKey = (params?: GetWidgetsParams,) => {
    return [
    `/api/v1/widgets`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWidgetsQueryOptions = <TData = Awaited<ReturnType<typeof getWidgets>>, TError = ErrorType<unknown>>(params: GetWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWidgetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWidgets>>> = ({ signal }) => getWidgets(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWidgetsQueryResult = NonNullable<Awaited<ReturnType<typeof getWidgets>>>
export type GetWidgetsQueryError = ErrorType<unknown>


export function useGetWidgets<TData = Awaited<ReturnType<typeof getWidgets>>, TError = ErrorType<unknown>>(
 params: GetWidgetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWidgets>>,
          TError,
          Awaited<ReturnType<typeof getWidgets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWidgets<TData = Awaited<ReturnType<typeof getWidgets>>, TError = ErrorType<unknown>>(
 params: GetWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWidgets>>,
          TError,
          Awaited<ReturnType<typeof getWidgets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWidgets<TData = Awaited<ReturnType<typeof getWidgets>>, TError = ErrorType<unknown>>(
 params: GetWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all widgets that appear on the specified page
 */

export function useGetWidgets<TData = Awaited<ReturnType<typeof getWidgets>>, TError = ErrorType<unknown>>(
 params: GetWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWidgetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






